/* Copyright (c) 2018 Environmental Systems Research Institute, Inc.
 * Apache-2.0 */
import { __assign } from "tslib";
import { request } from "@esri/arcgis-rest-request";
import { getPortalUrl } from "../util/get-portal-url";
/**
 * ```js
 * import { getUserNotifications } from '@esri/arcgis-rest-portal';
 * // username is inferred from UserSession
 * getUserNotifications({ authentication })
 *   .then(results) // results.notifications.length) => 3
 * ```
 * Get notifications for a user.
 *
 * @param requestOptions - options to pass through in the request
 * @returns A Promise that will resolve with the user's notifications
 */
export function getUserNotifications(requestOptions) {
    var options = { httpMethod: "GET" };
    var username = encodeURIComponent(requestOptions.authentication.username);
    var portalUrl = getPortalUrl(requestOptions);
    var url = portalUrl + "/community/users/" + username + "/notifications";
    options = __assign(__assign({}, requestOptions), options);
    // send the request
    return request(url, options);
}
/**
 * Delete a notification.
 *
 * @param requestOptions - Options for the request
 * @returns A Promise that will resolve with the success/failure status of the request
 */
export function removeNotification(requestOptions) {
    var username = encodeURIComponent(requestOptions.authentication.username);
    var portalUrl = getPortalUrl(requestOptions);
    var url = portalUrl + "/community/users/" + username + "/notifications/" + requestOptions.id + "/delete";
    return request(url, requestOptions);
}
//# sourceMappingURL=notification.js.map